import React, { useState } from 'react';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import { IconButton, Menu, MenuItem, useMediaQuery } from '@material-ui/core';
import { useTheme } from '@material-ui/core/styles';
import MenuIcon from '@material-ui/icons/Menu';

const MobileMenu = ({ links }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const history = useHistory();

  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleOpen = event => setAnchorEl(event.currentTarget);
  const handleClose = () => setAnchorEl(null);

  if (!isMobile) {
    return null;
  }

  return (
    <>
      <IconButton color="inherit" onClick={handleOpen}>
        <MenuIcon />
      </IconButton>
      <Menu anchorEl={anchorEl} open={open} onClose={handleClose}>
        {links.map(link => (
          <MenuItem
            key={link.id}
            onClick={() => {
              handleClose();
              history.push(link.href);
            }}
          >
            {link.text}
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};

export default MobileMenu;
